import React, { useRef } from 'react';
import { useEffect } from 'react';
import {IProps} from './types';
import * as S from './styles';
import { default as C } from '@assets/themes/colors';
import { ArrowDownIcon } from '@assets/icons/arrowDownIcon';

const Accordion:React.FC<IProps> = (props) => {
  const accordionRef = useRef<null | any>(null);

  function isInViewport(element: HTMLElement) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  useEffect(() => {
    if (props.active) {
      const topElement = document.getElementById("top" + props.index);
      if (topElement) {
        if (!isInViewport(topElement)) {
          topElement.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    }
  }, [props.active])

  return (
    <S.AccordionItem id={'top' + props.index} key={`accordion-item-${props.index}`} hoverHighlight={props.hoverHighlight} active={props.active}>
      <S.AccordionTitle
        active = {props.active}
        activeColor = {props.activeColor}
        onClick={() => {
          props.onClick(props.index);
        }}
      >
        {props.title}
        <S.Icons active={props.active}>
          <ArrowDownIcon style={{fillColor: ((props.active && props.activeColor) ? props.activeColor : C.DARK_BLUE)}} />
        </S.Icons>
        <S.Counter>{props.message??""}</S.Counter>
      </S.AccordionTitle>
      <S.AccordionBody active={props.active} bodyHeight={accordionRef?.current?.clientHeight ? accordionRef.current.clientHeight : 0}>
        <S.AccordionContent ref={accordionRef}>
          {props.children} 
        </S.AccordionContent>
      </S.AccordionBody>
    </S.AccordionItem>
  );
}

export default Accordion;